(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/settings/reports', {
      templateUrl: 'modules/app/settings/cards/cards.html',
      controller: 'CardListerCtrl',
      requiredPermissions: ['admin', 'manager']
    });
  }]).controller('CardListerCtrl', ['$scope', 'Card', '$rootScope', 'CardRegistry', '$timeout', 'wsEventNames', '$q', '$filter', 'CardUtils', 'CardGroup', 'Demo', 'OrganizationSettings', 'User', '$uibModal', function ($scope, Card, $rootScope, CardRegistry, $timeout, wsEventNames, $q, $filter, CardUtils, CardGroup, Demo, OrganizationSettings, User, $uibModal) {
    $scope.section = "reports";
    $scope.isLoading = {
      query: true,
      page: true
    };
    $scope.showPager = false;
    $scope.hidePageSize = false;
    $scope.keystrokeSearch = true;
    $scope.includeMetadata = true;
    $scope.searchTerm = '';
    $scope.sortBy = 'title';
    $scope.defaultSearchBy = 'title';
    $scope.searchPlaceholder = 'Search for a report';
    $scope.limit = 0;
    $scope.offset = 0;
    $scope.pages = [];
    $scope.pageNumber = 1;
    $scope.hideTotalItems = false;
    $scope.resultCount = 0;
    $scope.currentListing = [];
    $scope.minPage = $scope.currentListing.length > 0 ? 1 : 0;
    $scope.maxPage = $scope.pages[$scope.pages.length - 1];

    // Remove the breadcrumb when navigating to the reports page.
    $rootScope.$emit('headline:reset');
    OrganizationSettings.getForOrganization(User.get().organization ? User.get().organization.id : -1).then(function (settings) {
      $scope.isEssentialsOrg = settings ? settings.pricingTier === 'ESSENTIALS' : false;
    });
    $scope.fetchData = function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _limit = _ref._limit,
        _offset = _ref._offset,
        includeMetadata = _ref.includeMetadata,
        searchTerm = _ref.searchTerm;
      return !$scope.cardGroups ? $q.all([Card.getPage(_limit, _offset, includeMetadata, searchTerm), CardGroup.getAll()]).then(function (r) {
        $scope.resultCount = r[0].data.count;
        r[0].data.results.forEach(CardRegistry.add);
        postFetch([r[0].data.results, r[1]]);
      }) : Card.getPage(_limit, _offset, includeMetadata, searchTerm).then(function (r) {
        $scope.resultCount = r.data.count;
        r.data.results.forEach(CardRegistry.add);
        postFetch([r.data.results]);
      });
    };
    function postFetch(results) {
      if (!$scope.cardGroups) {
        $scope.cardGroups = _.object(_.pluck(results[1], 'id'), results[1]);
        $scope.cardGroupCards = results[0].filter(function (c) {
          return c.template.name === "card-group";
        });
        $scope.cardGroupCards = _.object(_.map($scope.cardGroupCards, function (c) {
          return c.configuration.cardGroupId;
        }), $scope.cardGroupCards);
      }
      $scope.currentListing = results[0].map(function (card) {
        card.dashboards = card.cardGroupIds.map($scope.getDashboardName);
        card.onYourReportsDashboard = _.contains(_.pluck(card.cardGroupIds.map($scope.getDashboardName), "name"), "Your Reports");
        return card;
      });
      $scope.numPages = Math.ceil($scope.resultCount / $scope.pageSize);
      $scope.minPage = $scope.currentListing.length > 0 ? 1 : 0;
      $scope.maxPage = $scope.pages[$scope.pages.length - 1];
      $scope.resetPageListing();
      $scope.isLoading = {
        query: false,
        page: false
      };
    }
    $scope.getCardUrl = CardUtils.getCardUrl;
    $scope.edit = function (card) {
      CardRegistry.add(card);
      $rootScope.$broadcast("explore-card", {
        cardId: card.id
      });
    };
    $scope.delete = function (id) {
      Card.remove(id).then(function () {
        var idx = _.findIndex($scope.currentListing, {
          id: id
        });
        $scope.currentListing.splice(idx, 1);
      });
    };
    $scope.getDashboardName = function (id) {
      if (!$scope.cardGroups[id]) {
        return {
          name: 'Private Dashboard'
        };
      }
      if (!$scope.cardGroups[id].dashboard) {
        var cardGroup = $scope.cardGroupCards[id];
        if (cardGroup) {
          var dashNames = cardGroup.cardGroupIds.map($scope.getDashboardName);
          return {
            name: ' (' + dashNames.map(function (d) {
              return d.name;
            }).join(', ') + ')',
            cardGroupName: cardGroup.title
          };
        }
      }
      return {
        name: $scope.cardGroups[id].name
      };
    };
    $scope.assignCard = function (card) {
      var passScope = $scope.$new();
      passScope.card = card;
      return $uibModal.open({
        templateUrl: 'modules/app/settings/dashboards/modals/dashboard-access.html',
        controller: 'DashboardAccessModalCtrl',
        backdrop: 'static',
        scope: passScope
      });
    };
    $scope.viewReportInformation = function (card) {
      var passScope = $scope.$new();
      passScope.card = card;
      // passScope.dashboards = card.cardGroupIds.map(id => $scope.getDashboardName(id));
      return $uibModal.open({
        templateUrl: 'modules/app/settings/cards/report-info-modal.html',
        controller: 'ReportInfoModalCtrl',
        backdrop: 'static',
        scope: passScope,
        size: 'lg'
      });
    };
    $scope.$watch('searchTerm', function () {
      $scope.isLoading.query = true;
    });
    $scope.$watch('pageNumber', function () {
      $scope.isLoading.page = true;
    });
    $scope.fetch = function fetch() {
      return $scope.fetchData({
        _limit: $scope.pageSize,
        _offset: $scope.pageSize * ($scope.pageNumber - 1),
        includeMetadata: $scope.includeMetadata,
        searchTerm: $scope.searchTerm
      });
    };
    $scope.fetchSearchSuggestions = function fetchSearchSuggestions(params) {
      if ($scope.searchTerm !== params.in_title) {
        $scope.pageNumber = 1;
      }
      $scope.searchTerm = params.in_title;
      return $scope.fetch();
    };
  }]);
})();
